import to from 'await-to-js'
import client from '@/api/client'
import ownerCardDataQuery from '@/api/gql/owner-card/query/owner-card-data.gql'

let isFetchingData = false

export default {
  namespaced: true,
  state: {
    genders: [],
    terrains: [],
    weeklyDistances: [],
    purchaseChannels: [],
    products: [],
  },

  getters: {
    isLoaded: state => state.genders.length > 0,
  },

  mutations: {
    setData(state, { genders, terrains, weeklyDistances, purchaseChannels, products }) {
      state.genders = genders
      state.terrains = terrains
      state.weeklyDistances = weeklyDistances
      state.purchaseChannels = purchaseChannels
      state.products = products
    },
  },

  actions: {
    async fetchOwnerCardData({ commit }) {
      if (isFetchingData || this.isLoaded) return

      isFetchingData = true
      const [error, result] = await to(client.query({ query: ownerCardDataQuery }))
      isFetchingData = false

      if (error) throw error
      if (!result) throw new Error('Fetching owner card data failed')

      const { ownerCardData } = result.data
      commit('setData', ownerCardData)
    },
  },
}
